import {
  EDIT_PIPE_INVENTORY_PERMISSION,
} from '../constants/permissions';

const EXTRA_KEYS = ['project', 'analysis', 'pipe_inventory', 'map', 'devices'] as const;

/** Flatten user_extra_details permission IDs for hasPermission checks. */
export function collectUserExtraPermissionIds(extra: unknown): Set<string> {
  const ids = new Set<string>();
  if (!extra || typeof extra !== 'object') return ids;

  const record = extra as Record<string, unknown>;
  EXTRA_KEYS.forEach((key) => {
    const arr = record[key];
    if (!Array.isArray(arr)) return;
    arr.forEach((id) => {
      if (typeof id !== 'string') return;
      ids.add(id === 'add_pipe_inventory' ? EDIT_PIPE_INVENTORY_PERMISSION : id);
    });
  });

  return ids;
}
